import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export function useTeamTaxDiscountSchema() {
   const { t } = useI18n();

   const TEAM_TAX_DISCOUNT_SCHEMA = yup.object().shape({
      team_tax_discount_type_id: yup.number().required().label(t('general.team-tax-discount-types')),
      from: yup.string().required().label(t('generic.dates.from')),
      till: yup.string().nullable().optional().label(t('generic.dates.till')),
      bis_monthly_percentages: yup.array().optional(),
   });

   return { TEAM_TAX_DISCOUNT_SCHEMA };
}

export function getDefaultTeamTaxDiscountData() {
   return {};
}
